import {SxProps, Theme} from "@mui/material";

const STYLES = {
  assistantPaper: {
    height: "100%",
    borderRadius: "0px",
    position: "relative",
    display: "flex",
    flexDirection: "column",
  } as SxProps,
  assistantChatBody: {
    py: 2,
    px: 1,
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: (theme: Theme) => theme.palette.grey[400],
      borderRadius: "4px",
    },
  } as SxProps,
  assistantPromptInputBox: {
    pt: 1,
    pb: 1,
    px: 1.5,
  } as SxProps,
};

export default STYLES;
